import type { CheckinAnswer } from 'server/types/public-overrides';
import { isStuckStandup, summaryRows } from 'shared/checkin-feedback';

type Props = {
  kind: 'standup' | 'summary';
  answers: CheckinAnswer[];
  body: string;
  /** Coaches see the stuck answer and the nudge line picked out. */
  highlight?: boolean;
};

export function CheckinItemBody({ kind, answers, body, highlight }: Props) {
  if (kind === 'summary') {
    return (
      <table class="w-full text-sm border-collapse">
        <tbody>
          {summaryRows(body).map((row, i) => (
            <tr
              key={i}
              class={`border-t first:border-t-0 border-gray-100 dark:border-gray-700 ${
                highlight && row.isNudge ? 'bg-amber-50 dark:bg-amber-900/30' : ''
              }`}
            >
              <th
                scope="row"
                class="text-left align-top font-semibold normal-case tracking-normal text-sm bg-transparent text-gray-800 dark:text-gray-200 py-1.5 pl-0 pr-3 w-1/3 max-w-40"
              >
                {row.label}
              </th>
              <td class="align-top py-1.5 px-0 text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap">
                {row.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
  return (
    <div class="flex flex-col gap-3">
      {answers.map((answer, i) => {
        const isStuck = highlight && isStuckStandup([answer]);
        return (
          <div
            key={i}
            class={`flex flex-col ${
              isStuck
                ? 'border-l-4 border-amber-400 bg-amber-50 dark:bg-amber-900/30 pl-3 py-1'
                : ''
            }`}
          >
            <p class="font-semibold text-gray-800 dark:text-gray-200">{answer.prompt}</p>
            <p class="whitespace-pre-wrap">{answer.answer}</p>
          </div>
        );
      })}
    </div>
  );
}
